import React, { Component } from "react";
import PropTypes from "prop-types";
import { Menu as AntdMenu, Dropdown as AntdDropdown } from "antd";
import Text from "../Text";

import { styleUtils } from "../../utils";

import styles from "./styles";

const { style } = styleUtils;

const SDropdown = style(AntdDropdown, styles.dropdown);
const SMenu = style(AntdMenu, styles.menu);
const SMenuLabel = style(Text, styles.smenulabel);
const SMenuSublabel = style(Text, styles.sublabel);
const Label = style(Text, styles.label);

class Dropdown extends Component {
  handleOnItemClick = ({ key }) => {
    const { onChange } = this.props;
    const value = key.split("_")[0];
    onChange && onChange(value);
  };

  menu = items => (
    <SMenu onClick={this.handleOnItemClick}>
      {items.map(({ value, label, sublabel, disabled = false }) => (
        <SMenu.Item disabled={disabled} key={`${value}_${label}`}>
          <SMenuLabel>
            {label}
            {sublabel ? (
              <SMenuSublabel size="placeholder">{` ${sublabel}`}</SMenuSublabel>
            ) : null}
          </SMenuLabel>
        </SMenu.Item>
      ))}
    </SMenu>
  );

  Item = ({ value, label, disabled = false }) => (
    <SMenu.Item>{label}</SMenu.Item>
  );

  render() {
    const { items, text, height } = this.props;
    return (
      <SDropdown
        overlayStyle={styles.overlayStyle(height)}
        overlay={this.menu(items)}
      >
        <Label size="small">{text}</Label>
      </SDropdown>
    );
  }
}

Dropdown.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      sublabel: PropTypes.string,
      disabled: PropTypes.bool
    })
  ).isRequired,
  text: PropTypes.string,
  onChange: PropTypes.func,
  height: PropTypes.number
};

Dropdown.defaultProps = {
  height: 206
};

export default Dropdown;
